<template>
    <div class="categoliesBg">
        <!-- 导航栏 -->
        <Header :title="$t('T_SEARCH_CONDITION')" link="home"></Header>
        <div class="appContent size">
            <div class="panel-box-com">
                <span class="install-tip">{{$t('T_ALERT_INPUT_INSTALLATION_CONDITION')}}</span>
                <div class="panel-box-title">{{ $t('T_SCALE') }}</div>
                <van-row gutter="20">
                    <van-col span="24">
                      <dropdown v-model="unitData" :selectData="unitDataOptionsFormat" :label="'label'"></dropdown>
                    </van-col>
                </van-row>
                <div class="panel-box-title">{{ $t('T_LENS_THROW_DISTANCE') }}</div>
                <van-row gutter="20">
                    <van-field class="toggle-box-item" v-model='throwDistance' type="number" :formatter="formatter" format-trigger="onBlur">
                      <span slot="button" class="field-tip">{{ unitLabel }}</span>
                    </van-field>
                </van-row>
                <div class="panel-box-title">{{ $t('T_SCREEN_SIZE') }}</div>
                <van-row gutter="20">
                    <van-col span="24">
                      <dropdown v-model="dwhSelect" :selectData="dwhSelectOptions" :label="'label'"></dropdown>
                      <van-field class="toggle-box-item" v-model='screenSizeData' type="number" :formatter="formatter" format-trigger="onBlur">
                        <span slot="button" class="field-tip">{{ dwhSelect !== '0' ? unitLabel : 'inch'}}</span>
                      </van-field>
                    </van-col>
                </van-row>
                <div class="panel-box-title">{{ $t('T_ASPECT_RATIO') }}</div>
                <van-row gutter="20">
                    <van-col span="24">
                      <dropdown v-model="aspectRatioData" :selectData="aspectRatioOptions" :label="'label'"></dropdown>
                    </van-col>
                </van-row>
            </div>
            <div class="lip-hr"></div>
            <div class="panel-box-com special-collapse">
              <van-collapse v-model="activeNames">
                <van-collapse-item name="1" :title="$t('T_SEARCH_OPTION')">
                  <van-row gutter="20">
                    <div class="panel-box-title">{{ $t('T_INFO_BRIGHTNESS') }}</div>
                    <van-col span="24" class="padding-top-5">
                      <van-col span="10">
                        <van-field class="toggle-box-item" v-model='brightnessMin' type="number" :formatter="formatter" format-trigger="onBlur">
                          <span slot="button" class="field-tip">lumen</span>
                        </van-field>
                      </van-col>
                      <van-col span="4" style="text-align: center;">{{ $t('T_SEARCH_RANGE_TO') }}</van-col>
                      <van-col span="10">
                        <van-field class="toggle-box-item" v-model='brightnessMax' type="number" :formatter="formatter" format-trigger="onBlur">
                          <span slot="button" class="field-tip">lumen</span>
                        </van-field>
                      </van-col>
                    </van-col>
                  </van-row>
                  <van-row gutter="20">
                    <div class="panel-box-title">{{ $t('T_LENS_SHIFT') }}</div>
                    <van-col span="24">
                      <dropdown v-model="lesShiftData" :selectData="lesShift" :label="'label'"></dropdown>
                    </van-col>
                  </van-row>
                  <van-row gutter="20">
                    <div class="panel-box-title">{{ $t('T_AMBIENT') }}</div>
                    <van-col span="24" class="padding-top-5">
                      <van-col span="10">
                        <van-field class="toggle-box-item" v-model='ambientMin' type="number" :formatter="formatter" format-trigger="onBlur">
                          <span slot="button" class="field-tip">lx</span>
                        </van-field>
                      </van-col>
                      <van-col span="4" style="text-align: center;">{{ $t('T_SEARCH_RANGE_TO') }}</van-col>
                      <van-col span="10">
                        <van-field class="toggle-box-item" v-model='ambientMax' type="number" :formatter="formatter" format-trigger="onBlur">
                          <span slot="button" class="field-tip">lx</span>
                        </van-field>
                      </van-col>
                    </van-col>
                  </van-row>
                  <van-row gutter="20">
                    <div class="panel-box-title">{{ $t('T_ROOM_TYPE') }}</div>
                    <van-col span="24">
                      <dropdown v-model="appSelect" :selectData="application" :label="'label'"></dropdown>
                    </van-col>
                  </van-row>
                </van-collapse-item>
              </van-collapse>
            </div>
            <div class="btn-box">
              <van-button round type="info" size="large" @click="searchAction">{{ $t('T_SEARCH') }}</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import dropdown from '@/components/Dropdown'
import Header from '@/components/header'
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
      options: [],
      value: '',
      input: '',
      down: false,
      unitData: {},
      dwhSelect: '',
      aspectRatioData: '',
      screenSizeData: '',
      appSelect: '',
      throwDistance: '',
      brightnessMin: '',
      brightnessMax: '',
      throwRatioMin: '',
      throwRatioMax: '',
      lesShiftData: '',
      ambientMin: '',
      ambientMax: '',
      aspectRatioOptions: [{
        value: '4:3',
        label: '4:3'
      }, {
        value: '16:9',
        label: '16:9'
      }, {
        value: '16:10',
        label: '16:10'
      }],
      lesShift: [{
        value: '0',
        label: 'No'
      }, {
        value: '1',
        label: 'Yes'
      }],
      dwhSelectOptions: [
        {
          value: '0',
          label: this.$t('T_DIAGONAL')
        }, {
          value: '1',
          label: this.$t('T_WIDTH')
        }, {
          value: '2',
          label: this.$t('T_HEIGHT')
        }
      ],
      application: [{
        value: '0',
        label: this.$t('T_MEETING_ROOM')
      }, {
        value: '1',
        label: this.$t('T_CLASS_ROOM')
      }, {
        value: '2',
        label: this.$t('T_EVENT_HALL')
      }, {
        value: '3',
        label: this.$t('T_LIVING_ROOM')
      }, {
        value: '4',
        label: this.$t('T_THEATRE_ROOM')
      }],
      // 3, 5, 3, 3, 20   200 300 200 100 20
      applicationValue: [{
        limit: 3,
        bright: 200
      }, {
        limit: 5,
        bright: 300
      }, {
        limit: 3,
        bright: 200
      }, {
        limit: 3,
        bright: 100
      }, {
        limit: 20,
        bright: 20
      }],
      activeNames: ['1']
    }
  },

  components: {
    dropdown,
    Header
  },

  mounted () {
    this.aspectRatioData = this.aspectRatioOptions[0].label
    this.dwhSelect = this.dwhSelectOptions[0].value
    this.$nextTick(() => {
      this.unitData = this.unitDataOptionsFormat[0].value
    })
  },

  computed: {
    ...mapState([
      'unitDataOptions'
    ]),

    unitDataOptionsFormat () {
      let temp = []
      this.unitDataOptions.forEach((item) => {
        temp.push({
          value: item.value,
          label: this.$t(item.value)
        })
      })
      return temp
    },

    unitLabel () {
      let index = this.unitDataOptionsFormat.findIndex((item) => {
        return this.unitData === item.value
      })
      return (this.unitDataOptionsFormat[index] || {}).label
    }
  },

  methods: {
    changeDwhSelect () {
    },

    changeAspectRatio () {
    },

    searchAction () {
      let tempWidth = this.$commonJs.changeUnit(this.screenSizeData, this.unitData, true)
      let tempArray = this.aspectRatioData.split(':')
      // 对角线求宽度
      if (this.dwhSelect === '0') {
        let tempRatio = tempArray[0] / tempArray[1]
        tempWidth = this.$commonJs.changeUnit(this.screenSizeData, 'T_INCH_DECIMAL', true) * tempRatio / Math.sqrt(1 + Math.pow(tempRatio, 2))
      }
      // 高度求宽度
      if (this.dwhSelect === '2') {
        tempWidth = tempWidth * tempArray[0] / tempArray[1]
      }
      let temp = this.$commonJs.changeUnit(this.throwDistance, this.unitData, true) / tempWidth
      let result = []
      this.ProjectorSpec.forEach((item) => {
        var { matchingLensID, selectedLensInfo } = this.$commonJs.findLensInfo(item)
        // let realThrowRatio = (selectedLensInfo.throwRatio || '').split('-')
        // matchingLensID 匹配的lens，用throw ratio进行比较
        let realThrowRatio = (selectedLensInfo.throwRatio || '').split('-')
        if (realThrowRatio.length > 1 && temp >= realThrowRatio[0].trim() && temp <= realThrowRatio[1].trim()) {
          if (this.filterProjector(item) && this.filterLensInfo(selectedLensInfo)) {
            result.push(item)
          }
        } else if (realThrowRatio.length === 1 && temp === realThrowRatio[0].trim()) {
          if (this.filterProjector(item) && this.filterLensInfo(selectedLensInfo)) {
            result.push(item)
          }
        } else {
          if (this.comparenLesThrowratio(matchingLensID, temp)) {
            if (this.filterProjector(item) && this.filterLensInfo(selectedLensInfo)) {
              result.push(item)
            }
          }
        }
      })
      this.MATCHINGMODELDATA(result)
      this.SEARCHMATCHINGMODELDATA(result)
      // 设置condition值 输入/选择的单位、投影距离、屏幕尺寸、纵横比、房间的环境光、使用用途
      this.setCondition()
      this.$router.push({
        path: '/searchProjectors',
        query: {
          noSearch: true,
          link: 'tbd'
        }
      })
    },

    comparenLesThrowratio (matchingLensID, target) {
      let result = false
      for (let i = 0; i < matchingLensID.length; i++) {
        if (result) {
          break
        }
        for (let j = 0; j < this.OptionLensSpec.length; j++) {
          if (this.OptionLensSpec[j].id === matchingLensID[i]) {
            let temp = this.OptionLensSpec[j].throwRatio.split('-')
            if (temp.length < 2) {
              if (temp[0].trim() === target) {
                result = true
                break
              }
            } else {
              if (temp[0].trim() <= target && temp[1].trim() >= target) {
                result = true
                break
              }
            }
          }
        }
      }
      return result
    },

    filterProjector (projector) {
      let result = true
      // Brightness color
      result = this.$commonJs.matchRange(projector.color, this.brightnessMax, this.brightnessMin)
      // 获取对角线
      let screenSizeDiag = 0
      let aspectRatio = this.aspectRatioData.split(':')
      if (this.dwhSelect === '0') {
        screenSizeDiag = Math.pow(this.screenSizeData, 2) // inch
      } else if (this.dwhSelect === '1') {
        // 宽度求对角线
        // 单位 -> 厘米 -> 英尺
        let width = this.$commonJs.changeUnit(this.$commonJs.changeUnit(this.screenSizeData, this.unitData, true), 'T_INCH_DECIMAL')
        screenSizeDiag = (Math.pow(aspectRatio[0], 2) + Math.pow(aspectRatio[1], 2)) / Math.pow(aspectRatio[0], 2) * Math.pow(width, 2)
      } else {
        // 高度求对角线
        let height = this.$commonJs.changeUnit(this.$commonJs.changeUnit(this.screenSizeData, this.unitData, true), 'T_INCH_DECIMAL')
        screenSizeDiag = (Math.pow(aspectRatio[0], 2) + Math.pow(aspectRatio[1], 2)) / Math.pow(aspectRatio[1], 2) * Math.pow(height, 2)
      }
      if (this.ambientMin || this.ambientMax || this.ambientMin !== '' || this.ambientMax !== '') {
        let bright = 3
        if (this.appSelect !== '') {
          bright = this.applicationValue[this.appSelect].bright
        }
        let tempMin = screenSizeDiag * aspectRatio[0] * aspectRatio[1] * Math.pow(0.0254, 2) * bright * (this.ambientMin - 1) / (Math.pow(aspectRatio[0] * 1, 2) + Math.pow(aspectRatio[1], 2))
        let tempMax = screenSizeDiag * aspectRatio[0] * aspectRatio[1] * Math.pow(0.0254, 2) * bright * (this.ambientMax - 1) / (Math.pow(aspectRatio[0] * 1, 2) + Math.pow(aspectRatio[1], 2))
        result = this.$commonJs.matchRange(projector.color, tempMax, tempMin)
      } else if (this.appSelect !== '') {
        let temp = screenSizeDiag * aspectRatio[0] * aspectRatio[1] * Math.pow(0.0254, 2) * this.applicationValue[this.appSelect].bright * (this.applicationValue[this.appSelect].limit - 1) / (Math.pow(aspectRatio[0] * 1, 2) + Math.pow(aspectRatio[1], 2))
        if (projector.color * 1 < temp) {
          result = false
        }
      }
      return result
    },

    filterLensInfo (lensInfo) {
      let result = true
      let temp = (lensInfo.throwRatio || '').split('-')
      // 判断throwRatio
      if ((this.throwRatioMin && temp[0].trim() * 1 < this.throwRatioMin * 1) || (this.throwRatioMax && temp[1].trim() * 1 > this.throwRatioMax * 1)) {
        result = false
      }
      // 判断lensshift
      if ((this.lesShiftData === '0' && lensInfo.lcd.lensShiftRange.v.max !== 0) || (this.lesShiftData === '1' && lensInfo.lcd.lensShiftRange.v.max === 0)) {
        result = false
      }
      return result
    },

    setCondition () {
      let params = {
        tbd: true
      }
      if (this.unitData) {
        this.SET_UNIT(this.unitData)
      }
      if (this.aspectRatioData || this.screenSizeData !== '') {
        params.aspectRatioData = this.aspectRatioData
      }
      if (this.screenSizeData || this.screenSizeData !== '') {
        params.dwhSelect = this.dwhSelect
        params.screenSizeData = this.screenSizeData
      }
      if (this.appSelect) {
        params.appSelect = this.appSelect
        params.brightness = this.applicationValue[this.appSelect].bright
      }
      if (this.ambientMax !== '') {
        params.brightness = this.ambientMax
      }
      this.SET_SEARCHPARAMS(params)
    },

    formatter (value) {
      if (value === '') {
        return value
      }
      return (value * 1).toFixed(1) * 1
    },

    ...mapMutations([
      'SEARCHMATCHINGMODELDATA',
      'MATCHINGMODELDATA',
      'SET_UNIT',
      'SET_GRAPH_PJY',
      'SET_APPLICATION',
      'SET_BRIGHTNESS',
      'SET_SEARCHPARAMS'
    ])
  }
}
</script>
<style scoped>
    .appContent {
        padding-bottom: 20px;
    }

    .padding-top-5 {
        padding-top: 5px;
    }

    .special-collapse {
      padding-left: 0;
      padding-right: 0;
      padding-top: 0;
    }

    .lip-hr {
      width: 100%;
      height: 4px;
      background: #ebebeb;
    }

  .install-tip {
    display: inline-block;
    color: #999999;
    font-size: 12px;
  }
</style>
